module.exports = __webpack_public_path__ + "img/perforaciones_4-3_2048.4afa2698.jpg";